// extracted by mini-css-extract-plugin
module.exports = {"button":"Copy_button__Hcrbf"};